(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/product-start-page/assets/javascripts/rounds/views/rounds.js') >= 0) return;  svs.modules.push('/components/app/product-start-page/assets/javascripts/rounds/views/rounds.js');

'use strict';


svs.app.productStartPage.rounds.views.Rounds = Marionette.View.extend({
  className: 'rounds',
  regions: {
    tabs: '.rounds-tabs',
    holder: '.rounds-content-holder',
    scroller: '.rounds-content-scroller'
  },
  ui: {
    scroller: '.rounds-content-scroller',
    holder: '.rounds-content-holder',
    content: '.rounds-content',
    scrollIconLeft: '.js-rounds-scroll-icon-left',
    scrollIconRight: '.js-rounds-scroll-icon-right'
  },
  scrollLength: 0,
  scrollTimeOutIndex: null,
  initialize: function(options) {
    this.options = options || this.options;
  },
  template: function(data) {
    return svs.app.product_start_page.templates.rounds(data);
  },
  templateContext: function() {
    return {
      tabs: this.options.tabs
    };
  },
  events: {
    'click @ui.scrollIconLeft': 'scrollLeft',
    'click @ui.scrollIconRight': 'scrollRight'
  },
  onAttach: function() {
    if (this.options.tabs) {
      var groupByDate = _.groupBy(this.collection.models, function(model) {
        var gameDate = new Date(model.get('stopDate'));
        return String(gameDate.getFullYear()) + String(gameDate.getMonth() + 1) + String(gameDate.getDate());
      });
      var groupToArray = [];
      for (var key in groupByDate) {
        if (Object.prototype.hasOwnProperty.call(groupByDate, key)) {
          groupToArray.push(groupByDate[key]);
        }
      }
      var groupToArrayMap = groupToArray.map(function(arr, i) {
        return {
          date: arr[0].get('stopDate'),
          group: 'roundGroup' + (i + 1),
          active: i === 0,
          items: new Backbone.Collection(arr)
        };
      });

      var groupedCollection = new Backbone.Collection(groupToArrayMap);
      var tabsNavigation = new svs.app.productStartPage.rounds.views.RoundsTabs({ collection: groupedCollection });
      var tabsContent = new svs.app.productStartPage.rounds.views.RoundsTabsContent({ collection: groupedCollection });

      this.showChildView('tabs', tabsNavigation);
      this.showChildView('holder', tabsContent);
      this.listenTo(
        groupedCollection,
        'change:active',
        this.setScrollPosition,
        this
      );

      this.$el.addClass('rounds-columns');

      this.onResizeBind = _.bind(this.windowResize, this);
    } else {
      var content = new svs.app.productStartPage.rounds.views.RoundsItems({
        collection: this.collection
      });
      this.$el.addClass('rounds-table');
      this.showChildView('holder', content);
      this.onResizeBind = _.bind(this.windowResizeScroller, this);
    }

    this.setScrollPosition(null, true);
    this.onRoundsScrollBind = _.bind(this.onScroll, this);

    this.ui.scroller.on('scroll', this.onRoundsScrollBind);
    $(window).on('resize', this.onResizeBind);

    this.ui.scroller.trigger('scroll');
  },
  windowResize: function() {
    this.setHeight();
  },
  windowResizeScroller: function() {
    this.ui.scroller.trigger('scroll');
  },
  setScrollPosition: function(model, state) {
    if (state) {
      this.setHeight();
      this.ui.scroller.scrollLeft(0);
      $(window).trigger('resize');
      this.ui.scroller.trigger('scroll');
    }
  },
  setHeight: function() {
    this.ui.content.height(this.ui.holder.height());
    this.setScrollLength();
  },
  setScrollLength: function() {
    var roundWidth = 256;
    var windowWidth = $(window).width();

    if (roundWidth * 3 < windowWidth) {
      this.scrollLength = roundWidth * 3;
    } else if (roundWidth * 2 < windowWidth) {
      this.scrollLength = roundWidth * 2;
    } else {
      this.scrollLength = roundWidth;
    }
  },
  scrollLeft: function() {
    this.ui.scroller.animate(
      { scrollLeft: this.ui.scroller.scrollLeft() - this.scrollLength },
      500
    );
  },
  scrollRight: function() {
    this.ui.scroller.animate(
      { scrollLeft: this.ui.scroller.scrollLeft() + this.scrollLength },
      500
    );
  },
  onDestroy: function() {
    $(window).off('scroll', this.onRoundsScrollBind);
    $(window).off('resize', this.onResizeBind);
  },
  onScroll: function() {
    var self = this;

    if (this.scrollTimeOutIndex) {
      clearTimeout(this.scrollTimeOutIndex);
    }

    this.scrollTimeOutIndex = setTimeout(function() {
      if (self._isDestroyed) {
        return;
      }

      if (self.ui.scroller.scrollLeft() === 0) {
        self.ui.scrollIconLeft.addClass('hide-icon');
      } else {
        self.ui.scrollIconLeft.removeClass('hide-icon');
      }
      if (
        self.ui.scroller.scrollLeft() + self.ui.scroller.width() ===
          self.ui.scroller[0].scrollWidth
      ) {
        self.ui.scrollIconRight.addClass('hide-icon');
      } else {
        self.ui.scrollIconRight.removeClass('hide-icon');
      }
    }, 100);
  }
});



 })(window);